import TextInput from "Components/molecule/inputs/text-input"
import SearchSelect from "Components/molecule/inputs/search-select"
import { SelectOption } from "Components/molecule/inputs/select-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import BillabilityUtilizationTargetFields from "./types"

interface BillabilityUtilizationTargetFormProps extends FormProps<BillabilityUtilizationTargetFields> {
    fiscalYears: SelectOption[]
}

const FISCAL_YEAR_KEY = 'fiscalYear'
const UTILIZATION_KEY = 'utilizationTarget'
const ACTUAL_BILLABLE_KEY = 'actualBillableTarget'
const LEADS_KEY = 'leadsTarget'
const PRINCIPALS_KEY = 'principalsTarget'

const BillabilityUtilizationTargetForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting,
    edit,
    setFieldValue,
    fiscalYears
}: BillabilityUtilizationTargetFormProps) => {

    return <div className="generate-documents-form">
        <SearchSelect
            name={FISCAL_YEAR_KEY}
            key={FISCAL_YEAR_KEY}
            label={"Fiscal Year*"}
            placeholder={"Select a fiscal year"}
            value={values.fiscalYear === '' ? '' : String(values.fiscalYear)}
            error={!!touched.fiscalYear && !!errors.fiscalYear}
            message={touched.fiscalYear ? errors.fiscalYear : undefined}
            options={fiscalYears}
            onChange={(option: SelectOption | null) => setFieldValue?.(FISCAL_YEAR_KEY, option ? Number(option.value) : '')}
            onBlur={handleBlur(FISCAL_YEAR_KEY)}
        />

        <TextInput
            type="number"
            touched={!!touched.utilizationTarget}
            name={UTILIZATION_KEY}
            key={UTILIZATION_KEY}
            label={"Utilization Target (%)*"}
            placeholder={"e.g. 80"}
            value={values.utilizationTarget}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.utilizationTarget && !!errors.utilizationTarget}
            message={touched.utilizationTarget ? errors.utilizationTarget : undefined}
        />

        <TextInput
            type="number"
            touched={!!touched.actualBillableTarget}
            name={ACTUAL_BILLABLE_KEY}
            key={ACTUAL_BILLABLE_KEY}
            label={"Billable Target (%)*"}
            placeholder={"e.g. 90"}
            value={values.actualBillableTarget}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.actualBillableTarget && !!errors.actualBillableTarget}
            message={touched.actualBillableTarget ? errors.actualBillableTarget : undefined}
        />

        <TextInput
            type="number"
            touched={!!touched.leadsTarget}
            name={LEADS_KEY}
            key={LEADS_KEY}
            label={"Leads Billable Target (%)"}
            placeholder={"e.g. 90"}
            value={values.leadsTarget}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.leadsTarget && !!errors.leadsTarget}
            message={touched.leadsTarget ? errors.leadsTarget : undefined}
        />

        <TextInput
            type="number"
            touched={!!touched.principalsTarget}
            name={PRINCIPALS_KEY}
            key={PRINCIPALS_KEY}
            label={"Principals Billable Target (%)"}
            placeholder={"e.g. 70"}
            value={values.principalsTarget}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.principalsTarget && !!errors.principalsTarget}
            message={touched.principalsTarget ? errors.principalsTarget : undefined}
        />

        <small className="text-muted d-block mb-3">
            Leads / Principals targets are optional; they are compared with the Actual Billable % of employees whose job title starts with Lead / Principal on Finance &gt; Financial KPI Metrics.
        </small>

        <PrimaryButton
            type='submit'
            onClick={() => handleSubmit()}
            disabled={isSubmitting || !isValid}
            className="w-100"
        >
            {isSubmitting ? "Submitting...." : edit ? "Update" : "Submit"}
        </PrimaryButton>
    </div>
}

export default BillabilityUtilizationTargetForm
